import React, { useState } from "react";
import CureBayModal from "./CureBayModal";
import { Button } from "@chakra-ui/react";

function CureBay() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setLoading(false);
  };

  const filePath = "public/img/FILE988505112023063018070.pdf";

  return (
    <>
      <Button
        color="white"
        w={{ base: "5rem", lg: "8rem" }}
        _hover={{
          bg: "teal.400",
        }}
        bg="teal.300"
        fontSize={{ base: "xs", lg: "sm" }}
        onClick={() => handleOpenModal()}
      >
        View File
      </Button>
      <CureBayModal
        isOpen={isOpen}
        onClose={handleCloseModal}
        file={filePath}
      />
    </>
  );
}

export default CureBay;
